// extracted by mini-css-extract-plugin
export default {"link":"RQ-z","disabled":"SQ-z"};